var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSecure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 25,
    fill: "#F2F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3196_38047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 20C38.8931 23.4443 43.9742 25.2376 49.1667 25C49.9227 27.5717 50.154 30.2691 49.8469 32.932C49.5398 35.5948 48.7006 38.1688 47.3791 40.5009C46.0575 42.833 44.2807 44.8756 42.1541 46.5075C40.0276 48.1393 37.5947 49.327 35 50C32.4054 49.327 29.9725 48.1393 27.846 46.5075C25.7194 44.8756 23.9426 42.833 22.621 40.5009C21.2995 38.1688 20.4603 35.5948 20.1532 32.932C19.8461 30.2691 20.0774 27.5717 20.8334 25C26.0259 25.2376 31.107 23.4443 35 20Z",
    fill: "#E9F2FF",
    stroke: "#2682EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.334 33.3337C33.334 33.7757 33.5096 34.1996 33.8221 34.5122C34.1347 34.8247 34.5586 35.0003 35.0007 35.0003C35.4427 35.0003 35.8666 34.8247 36.1792 34.5122C36.4917 34.1996 36.6673 33.7757 36.6673 33.3337C36.6673 32.8916 36.4917 32.4677 36.1792 32.1551C35.8666 31.8426 35.4427 31.667 35.0007 31.667C34.5586 31.667 34.1347 31.8426 33.8221 32.1551C33.5096 32.4677 33.334 32.8916 33.334 33.3337Z",
    stroke: "#2682EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 35V39.1667",
    stroke: "#2682EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3196_38047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecure);
export default __webpack_public_path__ + "static/media/icon-secure.9229b1d26e9fcda5d711245f6521b4da.svg";
export { ForwardRef as ReactComponent };